import { ButtonType } from "@components/Button/types";
import { Overlay } from "@components/Overlay";
import { useModal } from "@hooks";
import { Translations, i18n } from "@i18n";
import { Intercom } from "@services";

export const ConfirmAccountClosureModal = () => {
  const { dismiss } = useModal();

  return (
    <Overlay
      title={i18n.t(Translations.ConfirmAccountClosureModalTitle)}
      subtitle={i18n.t(Translations.ConfirmAccountClosureModalSubtitle)}
      cta={{
        primary: {
          title: i18n.t(Translations.ConfirmAccountClosureModalPrimaryCTA),
          type: ButtonType.Danger,
          onClick: () => {
            Intercom.showChat();
            dismiss();
          },
        },
        secondary: {
          title: i18n.t(Translations.ConfirmAccountClosureModalSecondaryCTA),
          onClick: dismiss,
        },
      }}
      horizontal
    />
  );
};
